import React from 'react';

const GanttChartPage = () => {
    return (
        <div>
            
        </div>
    );
}

export default GanttChartPage;
